export default __webpack_public_path__ + "static/media/BlankImage.522560c8.jpg";